// About.jsx
import React from "react";
import "../styles/About.css";
import { FaBullseye, FaHandshake, FaUsers } from "react-icons/fa";

function About() {
  return (
    <div className="about-page">
      <section className="hero">
        <h1>Compassionate Farewell Services</h1>
        <p>
          Honoring lives with dignity through professional and respectful 
          funeral arrangements
        </p>
      </section>

      <section className="section">
        <h2 className="section-title">Our Commitment</h2>
        <p className="section-description">
          We provide comprehensive funeral services that respect cultural 
          traditions while offering modern conveniences.
        </p>

        <div className="values-grid">
          <div className="value-card">
            <FaBullseye className="value-icon" />
            <h3>Our Mission</h3>
            <p>
              Deliver compassionate services that ease family burdens during 
              difficult transitions
            </p>
          </div>

          <div className="value-card">
            <FaHandshake className="value-icon" />
            <h3>Our Promise</h3>
            <p>
              Transparent, respectful arrangements tailored to individual 
              needs and traditions
            </p>
          </div>

          <div className="value-card">
            <FaUsers className="value-icon" />
            <h3>Our Values</h3>
            <p>
              Integrity, empathy, and professionalism guide every service 
              we provide
            </p>
          </div>
        </div>
      </section>

      <section className="section contact-section">
        <h2 className="section-title">24/7 Support</h2>
        <p>Immediate assistance when you need it most</p>
        <button className="contact-button">
          Get Immediate Help
        </button>
      </section>
    </div>
  );
}

export default About;